@for (year of newFnolRequestList; track year) {
  <div class="year-item" [class.collapsed]="!year.expanded">
    <div class="year-title-container">
      <div class="year-title">
        <div class="year-title-text">
          <p class="body-12">{{ year.year }}</p>
        </div>
        <div class="year-title-icon" (click)="toggleYear(year)">
          <mat-icon svgIcon="expand-up" [class.down]="!year.expanded"></mat-icon>
        </div>
      </div>
    </div>
    @if (year.expanded) {
      <div class="list">
        @for (fnolRequest of year.items; track fnolRequest) {
          <cpf-fnol-request-preview [fnolRequest]="fnolRequest"></cpf-fnol-request-preview>
        }
      </div>
    }
  </div>
}

@for (year of claimsYearList; track year) {
  <div class="year-item" [class.collapsed]="!year.expanded">
    <div class="year-title-container">
      <div class="year-title">
        <div class="year-title-text">
          <p class="body-12">{{ year.year }}</p>
        </div>
        <div class="year-title-icon" (click)="toggleYear(year)">
          <mat-icon svgIcon="expand-up" [class.down]="!year.expanded"></mat-icon>
        </div>
      </div>
    </div>
    @if (year.expanded) {
      <div class="list">
        @for (claim of year.items; track claim) {
          <div class="info-block" (click)="openClaim(claim)">
            <div class="header">
              <div class="title">
                <p class="tag-12">{{ 'claims-list.claim-id' | translate }}: {{ claim.identifier }}</p>
              </div>
              <div class="status" [ngClass]="getStatusClass(claim.status)">
                <p class="tag-12">{{ formatStatus(claim.status) | translate }}</p>
              </div>
            </div>
            <div class="rows-container">
              <div class="rows">
                <div class="row">
                  <div class="title">
                    <p class="body-14">{{ 'claims-list.name-label' | translate }}</p>
                  </div>
                  <div class="value">
                    <p class="subtitle-14">{{ petData?.pet_name }}</p>
                  </div>
                </div>
                @if (claim.type) {
                  <div class="row">
                    <div class="title">
                      <p class="body-14">{{ 'claims-list.category-label' | translate }}</p>
                    </div>
                    <div class="value">
                      <p class="subtitle-14">{{ claim.type }}</p>
                    </div>
                  </div>
                }
                @if (claim.paid_amount !== undefined) {
                  <div class="row">
                    <div class="title">
                      <p class="body-14">{{ 'claims-list.pay-out-label' | translate }}</p>
                    </div>
                    <div class="value">
                      <p class="subtitle-14">{{ claim.paid_amount | currency:'CHF':'symbol':'1.0-0'}}</p>
                    </div>
                  </div>
                }
                <!--<div class="row" *ngIf="claim.status == ClaimStatus.IN_PROGRESS || claim.status == ClaimStatus.NEW">
                <div class="title row-title-with-info">
                  <p class="body-14">{{ 'claims-list.expected-date' | translate }}</p>
                  <div class="info-button" (click)="openInfo($event)">i</div>
                </div>
                <div class="value">
                  <p class="subtitle-14">TODO ADD DATE</p>
                </div>
              </div>-->
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
}

@if (claimsYearList?.length === 0 && newFnolRequestList.length === 0) {
  <div class="empty-state">
    <mat-icon>description</mat-icon>
    <p class="subtitle-14">{{ 'claims-list.no-claims' | translate }}</p>
  </div>
}
